/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ApplicationHealthSummarySortCriteria {
    getFixupPrototypeFunction() { return ApplicationHealthSummarySortCriteria.fixupPrototype; }

    static newInstance(model: Partial<ApplicationHealthSummarySortCriteria>): ApplicationHealthSummarySortCriteria {
        let obj = Object.assign(new ApplicationHealthSummarySortCriteria(), model);
        ApplicationHealthSummarySortCriteria.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ApplicationHealthSummarySortCriteria>): ApplicationHealthSummarySortCriteria {
        if (!model) return null;
        return ApplicationHealthSummarySortCriteria.newInstance(<ApplicationHealthSummarySortCriteria> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ApplicationHealthSummarySortCriteria) {
        if (!obj) return;

        models.ApplicationHealthSummarySortCriteria.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ApplicationHealthSummarySortCriteria): boolean {
        Object.setPrototypeOf(obj, ApplicationHealthSummarySortCriteria.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    column: models.ApplicationHealthSummarySortColumn;

    ascending: boolean;

}
